import Vue from 'vue'
import MetaInfo from 'vue-meta-info'
import metaInfoMixin from '@/util/meta-info'

import App from './App.vue'
import router from '@/router'

Vue.mixin(metaInfoMixin)

Vue.use(MetaInfo)

router.afterEach(() => {
  window.scrollTo(0, 0)
})

new Vue({
  el: '#app',
  router,
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
})


// WEBPACK FOOTER //
// src/main.js